(function($, document, window, lq) {

    lq.onglet = (function() {
        return {
            initOnglet: function() {
                if ($('.nav-tabs').length > 0) {

                    var url = document.location.toString();
                    // if (url.match('#')) {
                    //    $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tabs('show');
                    // }

                    // Change hash for page-reload
                    $('.nav-tabs a').on('shown.bs.tab', function(e) {
                        window.location.hash = e.target.hash;
                    })

                    //Javascrip pour le fonctionnement du menu déroulant des onglets
                    const elementsMenu = document.getElementsByClassName("onglet-menu-item") //Array avec tout les liens d'onglets
                    const selectionner = document.querySelector('.onglet-menu-item.active'), //Selectionne l'element actif
                        elemId = selectionner.id, //Fait ressortir le Id
                        SplitId = elemId.split('-tab '), //Sépare le Id avec -tab 
                        caption = SplitId[1], //Selectionne la partie du Id qui est le titre
                        btn = document.getElementById('menu-ongle-btn'); //Localise le bouton 

                    if (btn != null) {
                        btn.setAttribute("data-caption", caption); //Change le titre du bouton

                        for (let i = 0; i < elementsMenu.length; i++) {
                            elementsMenu[i].addEventListener("click", function() {
                                const elemId = this.id, //Selectionne l'element cliquer
                                    SplitId = elemId.split('-tab '), //Sépare le Id avec -tab
                                    caption = SplitId[1], //Selectionne la partie du Id qui est le titre
                                    btn = document.getElementById('menu-ongle-btn'), //Localise le bouton 
                                    parent = this.parentElement;

                                btn.setAttribute("data-caption", caption); //Change le titre du bouton

                                //Change des classes et attrubuts pour fermer le menu
                                btn.setAttribute("aria-expanded", false);
                                btn.classList.add('collapsed');
                                parent.classList.remove('show');
                            });

                        }
                    }

                }
            }
        };
    })();

    window.lq = lq;

    //--> Auto trigger all self implemented functionalities on document ready
    lq.load.push(
        "lq.onglet", [
            'initOnglet'
        ]
    );

}($, document, window, (window.lq || {})));